export const Footer = () => (
  <footer
    data-testid="app-footer"
    className="border-t border-slate-800/70 mt-2"
  >
    <div className="max-w-[1700px] mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
      <span className="mono text-[10px] tracking-wide text-slate-500">
        © 2026 2639389 Alberta LTD · All Rights Reserved
      </span>
      <span className="mono text-[10px] tracking-wide text-slate-600">
        BioGovernor · DBCA Live — demonstration environment
      </span>
    </div>
  </footer>
);
